export default function initCopyToClipboard() {
  Alpine.data('copyToClipboard', () => ({
    copied: false,
    clickToCopy(event: Event) {
      const element = event.target as Element;

      const textToCopy = element.getAttribute('data-text') ?? '';
      if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard.writeText(textToCopy);
      }
    },
  }));
}
